var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vector",
    _vm._b(
      {
        style: { fill: _vm.defaultColor },
        attrs: { "show-viewbox": true, height: "100", width: "100" }
      },
      "vector",
      _vm.$props,
      false
    ),
    _vm._l(_vm.filteredLayers, function(layer, i) {
      return _c("layer", { key: i, attrs: { layer: layer } })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }